module.exports = __webpack_public_path__ + "img/shtempel'naja-produktsija.c5af3460.svg";